import { useEffect } from "react";
import { Link } from "react-router-dom";

import "./ComingSoon.css";

/**
 * MER-515 part 3: shown when a Supabase email sign-in link fails (expired /
 * invalid) and redirects back to the root with an #error hash, instead of the
 * silent ComingSoon placeholder. Reuses the ComingSoon card styling. The
 * triggering hash is cleared on mount so a refresh / back-nav doesn't replay
 * the error.
 */
const MESSAGES: Record<string, string> = {
  otp_expired:
    "This sign-in link has expired. Sign in below, or ask your Meridian contact for a new link.",
  access_denied: "This sign-in link is no longer valid. Please sign in below.",
};

const FALLBACK = "We couldn't finish signing you in from that link. Please sign in below.";

export default function AuthError({ code }: { code?: string | null }) {
  useEffect(() => {
    // Drop the consumed #error hash so a refresh / back-nav doesn't replay it.
    // The error was already snapshotted at module load (authError.mjs), so
    // clearing the URL here does not affect what this page renders.
    if (typeof window !== "undefined" && window.location.hash) {
      window.history.replaceState(null, "", window.location.pathname + window.location.search);
    }
  }, []);

  const message = (code && MESSAGES[code]) || FALLBACK;

  return (
    <main className="coming-soon">
      <section className="coming-soon__card">
        <div className="coming-soon__logo">
          <span className="coming-soon__logo-mark">M</span>
          <span className="coming-soon__logo-text">Meridian Analytics</span>
        </div>
        <span className="coming-soon__pill">Sign-in link</span>
        <h1 className="coming-soon__title">Your sign-in link didn&apos;t work.</h1>
        <p className="coming-soon__body">{message}</p>
        <Link className="coming-soon__signin" to="/login">
          Sign in
        </Link>
        <div className="coming-soon__meta">
          <b>dashboard.meridiananalytics.io</b>
          <br />
          Need a new link? Contact your Meridian account manager.
        </div>
      </section>
    </main>
  );
}
